import { HStack, Input, Text } from '@chakra-ui/react';
import { FieldError } from 'react-hook-form';
import { CustomFormControl } from '../CustomFormControl';
import { ChangeEvent, useEffect, useState } from 'react';
import { countriesList, ICountry } from './countries';
import InputMask from 'react-input-mask';
import { CustomSelect } from '../CustomSelect';
import { CountryBtnEl } from './CountryBtnEl';
import { findCountryByValue, getDefaultPhone, getMask, PHONE_PREFIX } from './helpers';

export interface ICustomInput {
  label?: string;
  placeholder?: string;
  name?: string;
  error?: FieldError | undefined;
  [x: string]: any;
}

const processListItems = countriesList.map(({ label, name }) => ({
  key: label,
  value: label,
  component: (
    <>
      <span className={`fi fi-${label}`} />
      <Text ml={2}>{name}</Text>
    </>
  ),
}));

export const CustomPhoneInput = (props: ICustomInput) => {
  const { label, error, placeholder, onChange, value, sx, ...restProps } = props;
  const [country, setCountry] = useState<string>(findCountryByValue(value)?.label || 'be');
  const [countryData, setCountryData] = useState<ICountry | undefined>(findCountryByValue(value));
  const [inputValue, setInputValue] = useState<string>(getDefaultPhone(value));

  useEffect(() => {
    setCountryData(countriesList.find((el: any) => el.label === country));
  }, [country, onChange, value]);

  const onHandleChanged = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e?.target.value.replace(/\D/g, ''));
  };

  useEffect(() => {
    if (onChange) {
      let phone = '';
      if (inputValue) {
        phone = `${PHONE_PREFIX}${countryData?.code}${inputValue}`;
      }
      onChange(phone);
    }
  }, [inputValue, onChange, countryData?.code]);

  return (
    <CustomFormControl label={label} error={error} errorMessageSx={{ justifyContent: 'flex-end' }} sx={sx}>
      <HStack spacing={[3, 10]} width='100%'>
        <CustomSelect
          sx={{ maxWidth: '200px' }}
          onChange={setCountry}
          options={processListItems}
          renderBtnEl={() => <CountryBtnEl name={countryData?.label} code={countryData?.code} />}
        />

        <Input
          as={InputMask}
          placeholder={countryData?.placeholder || placeholder}
          mask={getMask(inputValue, countryData) || ''}
          maskPlaceholder='x'
          onChange={onHandleChanged}
          defaultValue={getDefaultPhone(value)}
          {...restProps}
        />
      </HStack>
    </CustomFormControl>
  );
};
